<template>
    <modal-content @close="$emit('close')">
        <accessory-option-form ref="form" submit-button-value="Založit" @o3-submit="onSubmit($event)"/>
        <div class="form__row m--t-1">
            <custom-button type="button" @click="create" primaryadd><span icon>&plus;</span>Vytvořit nový typ
            </custom-button>
        </div>
    </modal-content>
</template>

<script>
import ModalContent from 'domovio-core/src/components/Modal/ModalContent';
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import CreateAccessoryTypeDialog
    from '@/modules/ProjectModule/modules/OptionModule/components/Accessory/CreateAccessoryTypeDialog';
import AccessoryOptionForm
    from '@/modules/ProjectModule/modules/OptionModule/components/Accessory/Option/AccessoryOptionForm';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'CreateAccessoryOptionDialog',
    components: {CustomButton, AccessoryOptionForm, ModalContent},
    methods:    {
        onSubmit(data) {
            this.$store.dispatch('projects/project/accessory/createAccessory', data)
                .then(() => {
                    this.$refs.form.reset();
                    this.$emit('close');
                }).catch((message) => this.$dmv.notifyError(message));
        },
        create() {
            this.$modal.show(CreateAccessoryTypeDialog, {}, defaultModalParameters());
        }
    }
}
</script>
